<div class="relative inline-block" (document:click)="onDocumentClick($event)">
  <button
    type="button"
    class="rounded border border-gray-300 px-1.5 py-0.5 font-mono text-[10px] text-gray-600 transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-white/5"
    [disabled]="disabled()"
    title="Insertar una variable en el texto"
    (click)="toggle()">
    {{ bracesLabel }}
  </button>

  @if (open()) {
    <!-- z-dropdown: el panel escapa del contenedor del inspector. -->
    <div class="z-dropdown absolute right-0 mt-1 max-h-72 w-72 overflow-y-auto rounded-lg border border-gray-200 bg-white py-1 shadow-lg dark:border-gray-700 dark:bg-gray-900">
      @if (!hasVariables()) {
        <p class="px-3 py-2 text-xs text-gray-500 dark:text-gray-400">
          No hay variables disponibles para este workflow.
        </p>
      } @else {
        @for (group of groups(); track group.source) {
          <p class="px-3 pb-1 pt-2 text-[10px] font-semibold uppercase tracking-wide text-gray-400 dark:text-gray-500">
            {{ group.label }}
          </p>
          @for (variable of group.variables; track variable.token) {
            <button
              type="button"
              class="flex w-full flex-col items-start gap-0.5 px-3 py-1.5 text-left transition hover:bg-gray-50 dark:hover:bg-white/5"
              (click)="insert(variable)">
              <span class="text-xs text-gray-700 dark:text-gray-200">{{ variable.label }}</span>
              <span class="font-mono text-[10px] text-gray-400 dark:text-gray-500">{{ tokenPreview(variable) }}</span>
            </button>
          }
        }
      }
    </div>
  }
</div>
